/* HOMEHEART — sajtövergripande JS. Laddas från layout/theme.liquid.
   Håll den liten: allt här körs på varje sidvisning. */
(function () {
  'use strict';

  /* ---- 1. Mobilmenyn -----------------------------------------------------
     När en toppkategori fälls ut hamnar listan ofta UNDER synligt område, så det
     ser ut som att inget händer. Rulla den öppnade rubriken till toppen av drawern.
     Focal renderar toppnivån som <button is="toggle-button" aria-controls="mobile-menu-N">
     eftersom posten har barn; aria-expanded växlar när den öppnas. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mobile-nav__link[aria-controls^="mobile-menu-"]');
    if (!btn) return;
    setTimeout(function () {                 // efter temats egen animation
      if (btn.getAttribute('aria-expanded') !== 'true') return;
      var scroller = btn.closest('.drawer__content') || btn.closest('.drawer');
      if (!scroller) return;
      var top = btn.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
      scroller.scrollTo({ top: scroller.scrollTop + top - 8, behavior: 'smooth' });
    }, 260);
  }, { passive: true });

  /* ---- 2. Kategoritexten -------------------------------------------------
     Temat renderar kategoribeskrivningen som overlay INUTI hero-bilden: centrerad
     vit text ovanpå ett foto, oläslig så fort den är längre än en mening. Den
     flyttas därför ut till ett eget block. Elementet är dolt i heron via CSS från
     start, så inget hinner blinka förbi innan flytten.

     PLACERINGEN ÄNDRAD 2026-08-01: texten låg under rutnätet. Nu ligger den ÖVER,
     eftersom kategorisidan fått två texter med olika uppgift:
       kort text (den här)  ->  produkter  ->  lång SEO-text (hh-seo-text.liquid)
     Den korta ska hjälpa besökaren avgöra om hen är rätt, och måste därför synas
     före produkterna. Den långa är skriven för sökmotorer och AI-svar och renderas
     serverside under rutnätet. */
  function flyttaKategoritext() {
    var kalla = document.querySelector(
      '.shopify-section--collection-banner .image-overlay__text-container');
    if (!kalla || !kalla.textContent.trim()) return;
    var rutnat = document.querySelector('.shopify-section--main-collection');
    if (!rutnat) return;

    var wrap = document.createElement('section');
    wrap.className = 'hh-collection-text';
    var inner = document.createElement('div');
    inner.className = 'hh-collection-text__inner';
    while (kalla.firstChild) inner.appendChild(kalla.firstChild);
    wrap.appendChild(inner);
    rutnat.insertAdjacentElement('beforebegin', wrap);
    kalla.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', flyttaKategoritext);
  } else {
    flyttaKategoritext();
  }

  /* ---- 3. Prisformat per marknad -----------------------------------------
     Shopify formaterar presenterade valutor (Markets) med sina egna standarder och
     de går inte att ändra i admin eller API — bara butiksvalutans format är
     inställbart. Resultatet: NOK renderades "11.135,00 kr" (norsk norm: "11 135 kr")
     och CHF "CHF 1,035.00" (schweizisk norm: "CHF 1'035.00"). CZK använde i sin tur
     butikens kontinentala format "2.542,00 Kč" i stället för tjeckiska "2 542 Kč".
     Enligt
     tiolandsresearchen är fel prisformat den snabbaste avslöjaren av en utländsk
     sajt. Rättas därför i klienten. MutationObserver täcker variantbyten och
     Ajax-laddade produktkort. SEK-normaliseringen kräver att talet står direkt
     intill "kr" eller "SEK", så andra tal på sidan lämnas orörda.           */
  function formateraPriser(rot) {
    var valuta = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    if (valuta !== 'SEK' && valuta !== 'NOK' && valuta !== 'CHF' && valuta !== 'CZK') return;
    var w = document.createTreeWalker(rot || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !/\d/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var el = n.parentElement;
        if (!el || el.closest('script,style,input,textarea')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var noder = [];
    for (var n = w.nextNode(); n; n = w.nextNode()) noder.push(n);
    noder.forEach(function (n) {
      var v = n.nodeValue;
      if (valuta === 'SEK' || valuta === 'NOK' || valuta === 'CZK') {
        /* 11.135,00 kr -> 11 135 kr  (punkttusental bort, ,00 bort; ,50 behålls) */
        var suffixPattern = valuta === 'CZK' ? 'Kč' : (valuta === 'SEK' ? '(?:kr|SEK)' : 'kr');
        var tusen = new RegExp('\\b(\\d{1,3}(?:\\.\\d{3})+),00(\\s?' + suffixPattern + ')', 'g');
        var enkel = new RegExp('\\b(\\d{1,4}),00(\\s?' + suffixPattern + ')', 'g');
        v = v.replace(tusen, function (_, tal, valutaText) {
          return tal.replace(/\./g, '\u00a0') + valutaText;
        }).replace(enkel, '$1$2');
        if (valuta === 'SEK') {
          /* 1,299 kr / 3,947 SEK -> 1 299 kr / 3 947 SEK. Mönstret kräver
             tresiffriga tusengrupper och kan därför inte träffa 76,95. */
          v = v.replace(/\b(\d{1,3}(?:,\d{3})+)(\s*(?:kr|SEK))\b/g, function (_, tal, valutaText) {
            return tal.replace(/,/g, '\u00a0') + valutaText;
          });
          /* 1299 kr -> 1 299 kr. Redan grupperade belopp och decimalbelopp matchar inte. */
          v = v.replace(/\b(\d{4,})(\s*(?:kr|SEK))\b/g, function (_, tal, valutaText) {
            return tal.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + valutaText;
          });
        }
      } else {
        /* CHF 1,035.00 -> CHF 1'035.00. I franskspråkiga Schweiz skrivs
           valutakoden efter beloppet: CHF 1,035.00 -> 1'035.00 CHF. */
        v = v.replace(/\b(CHF\s?)(\d{1,3}(?:,\d{3})+)(\.\d{2})?/g, function (_, chf, tal, dec) {
          return chf + tal.replace(/,/g, "'") + (dec || '');
        });
        if ((document.documentElement.lang || '').split(/[-_]/)[0] === 'fr') {
          v = v.replace(/\bCHF\s+(\d{1,3}(?:'\d{3})*(?:\.\d{2})?)/g, '$1\u00a0CHF');
        }
      }
      if (v !== n.nodeValue) n.nodeValue = v;
    });
  }
  function startaPrisformat() {
    formateraPriser(document.body);
    new MutationObserver(function (ml) {
      ml.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) formateraPriser(n);
          else if (n.nodeType === 3 && n.parentElement) formateraPriser(n.parentElement);
        });
        if (m.type === 'characterData' && m.target.parentElement) formateraPriser(m.target.parentElement);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startaPrisformat);
  } else {
    startaPrisformat();
  }

  /* ---- 4. Marknadsrätta betalikoner ------------------------------------
     Produktappens egen ikonlista är global och visar därför Swish även utanför Sverige.
     Swish är ett svenskt betalsätt och ska aldrig visas som köptrygghet på de lokala
     marknaderna. Övriga ikoner lämnas orörda tills checkoutmixen är verifierad. */
  function lokaliseraBetalikoner(rot) {
    var sprak = (document.documentElement.lang || '').split('-')[0].split('_')[0];
    if (sprak !== 'cs' && sprak !== 'nl' && sprak !== 'de' && sprak !== 'fr' && sprak !== 'it' && sprak !== 'no') return;
    var scope = rot && rot.querySelectorAll ? rot : document;
    var selector = '.ss-payment-item img[src*="swish" i]';
    var bilder = [];
    if (scope.matches && scope.matches(selector)) bilder.push(scope);
    scope.querySelectorAll(selector).forEach(function (img) { bilder.push(img); });
    bilder.forEach(function (img) {
      var item = img.closest('.ss-payment-item');
      if (item) item.remove();
    });
  }
  function startaBetalikoner() {
    lokaliseraBetalikoner(document);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        change.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) lokaliseraBetalikoner(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startaBetalikoner);
  } else {
    startaBetalikoner();
  }

  /* ---- 5. Policy-länkar på marknadsdomänen -----------------------------
     Shopifys cookie-dialog byggde länken med primärdomänen, t.ex.
     homeheart.se/cs/policies/privacy-policy, även när dialogen visas på .cz.
     Behåll kunden och samtyckesflödet på den lokala domänen. */
  function lokaliseraPolicyLankar(rot) {
    var host = window.location.hostname;
    if (host !== 'homeheart.cz' && host !== 'homeheart.nl' && host !== 'homeheart.ch' && host !== 'homeheart.no') return;
    var language = (document.documentElement.lang || '').split('-')[0].split('_')[0];
    var defaultLanguage = {
      'homeheart.cz': 'cs',
      'homeheart.nl': 'nl',
      'homeheart.no': 'no',
      'homeheart.ch': 'de'
    }[host];
    var localePrefix = language && language !== defaultLanguage ? '/' + language : '';
    var links = (rot || document).querySelectorAll
      ? (rot || document).querySelectorAll('a[href*="homeheart.se/"][href*="/policies/"]')
      : [];
    links.forEach(function (link) {
      try {
        var url = new URL(link.href);
        var policyPath = url.pathname.replace(/^\/(sv|cs|nl|de|fr|it|no)(?=\/policies\/)/, '');
        link.href = window.location.origin + localePrefix + policyPath + url.search + url.hash;
      } catch (_) { /* leave malformed third-party links untouched */ }
    });
  }
  function startaPolicyLankar() {
    lokaliseraPolicyLankar(document);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        change.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) lokaliseraPolicyLankar(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startaPolicyLankar);
  } else {
    startaPolicyLankar();
  }

  /* ---- 6. Lokala alt-texter för kategoribilder -------------------------
     Shopify översätter kollektionsrubriken men inte bildens altText. Focal faller
     därför tillbaka till den svenska källtiteln på lokala marknader. Använd den
     redan lokaliserade synliga rubriken för både kategoribanner och startsidans
     kategorikort, utan att skriva om själva innehållsobjekten. */
  function lokaliseraKategoriBilder() {
    var host = window.location.hostname;
    if (host !== 'homeheart.cz' && host !== 'homeheart.nl' && host !== 'homeheart.ch' && host !== 'homeheart.no') return;
    var banner = document.querySelector('.shopify-section--collection-banner');
    if (banner) {
      var heading = banner.querySelector('h1, h2');
      var image = banner.querySelector('img');
      if (heading && image && heading.textContent.trim()) {
        image.alt = heading.textContent.trim();
      }
    }

    document.querySelectorAll('.shopify-section--collection-list .list-collections__item').forEach(function (card) {
      var cardHeading = card.querySelector('.list-collections__item-info .heading, .list-collections__item-info [class*="heading"]');
      var cardImage = card.querySelector('.list-collections__item-image-wrapper img');
      if (cardHeading && cardImage && cardHeading.textContent.trim()) {
        cardImage.alt = cardHeading.textContent.trim();
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lokaliseraKategoriBilder);
  } else {
    lokaliseraKategoriBilder();
  }

  /* ---- 7. Exakta sorteringsetiketter för CZ/NL -------------------------
     Vissa Shopify-hanterade etiketter faller tillbaka till svensk källtext, och
     den tjeckiska Z-A-etiketten har ärvt svenska Ö. Ersätt endast kända exakta
     strängar inuti sorteringskontroller; produkt- och sidtext berörs aldrig. */
  var SORT_TEXT = {
    cs: {
      'Abecedně, Ö–A': 'Abecedně, Ž–A',
      'Bästsäljare': 'Nejprodávanější',
      'Relevance': 'Podle relevance'
    },
    nl: {
      'Alfabetiskt, Ö–A': 'Alfabetisch, Z–A',
      'Bästsäljare': 'Bestverkocht',
      'Relevans': 'Relevantie'
    }
  };
  function lokaliseraSortering(rot) {
    var sprak = (document.documentElement.lang || '').split('-')[0].split('_')[0];
    var replacements = SORT_TEXT[sprak];
    if (!replacements) return;
    var scope = rot && rot.querySelectorAll ? rot : document;
    var containers = [];
    var selector = '#sort-by-popover, [id^="sort-by"], [class*="sort-by"], select[name="sort_by"]';
    if (scope.matches && scope.matches(selector)) containers.push(scope);
    scope.querySelectorAll(selector).forEach(function (node) { containers.push(node); });
    containers.forEach(function (container) {
      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      var nodes = [];
      for (var node = walker.nextNode(); node; node = walker.nextNode()) nodes.push(node);
      nodes.forEach(function (node) {
        var value = node.nodeValue.trim();
        if (!replacements[value]) return;
        node.nodeValue = node.nodeValue.replace(value, replacements[value]);
      });
    });
  }
  function startaSortering() {
    lokaliseraSortering(document);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        change.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) lokaliseraSortering(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startaSortering);
  } else {
    startaSortering();
  }
})();
